const MyAccountPage = () => import('frontend/pages/account/MyAccountPage')
const MyAccountComponent = () => import('frontend/pages/account/MyAccountComponent')

import { ACCOUNT_ROUTE, MY_ACCOUNT_ROUTE } from 'frontend/routes/constants'

export const accountRoutes = [
  {
    path: `/${ACCOUNT_ROUTE}`,
    name: ACCOUNT_ROUTE,
    component: MyAccountPage,
    children: [{
      path: MY_ACCOUNT_ROUTE,
      name: MY_ACCOUNT_ROUTE,
      component: MyAccountComponent,
    }],
  },
]
